import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=7b6e655d&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&id=7b6e655d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e655d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6e655d')) {
      api.createRecord('7b6e655d', component.options)
    } else {
      api.reload('7b6e655d', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=7b6e655d&scoped=true&", function () {
      api.rerender('7b6e655d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/pagination.vue"
export default component.exports